let periods;
switch (COUNTRY) {
  case 'EE':
    periods = [6, 36, 60];
    break;
  case 'LV':
    periods = [1, 2, 6, 12, 60];
    break;
  case 'LT':
    periods = [3, 12, 36];
    break;
  case 'ES':
    periods = [1, 2, 3, 4, 6, 12, 18, 24, 30, 36];
    break;
  case 'CZ':
    periods = [1, 2, 3, 6, 9, 12, 18, 24];
    break;
  default:
    periods = [6, 24, 36];
}

export default [...periods];
